import { Component, Input } from '@angular/core';

@Component({
    selector: 'tmnz-tool-tip',
    templateUrl: './tool-tip.component.html',
    styleUrls: ['./tool-tip.component.scss'],
    standalone: false
})
export class ToolTipComponent {
  hideTooltip: boolean = true;

  @Input()
  position: string = 'left';

  @Input()
  iconName: string = 'info';

  onMouseEnter() {
    this.hideTooltip = false;
  }

  onMouseLeave() {
    this.hideTooltip = true;
  }
}
